import { useMemo } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import useCheckboxField from '../Checkbox/useCheckboxField';
import { CustomToggleProps } from './CustomToggle.types';

const usePresenter = (props: CustomToggleProps) => {
  const {
    checked,
    value,
    onValueChange,
    disabled = false,
    required = false,
    invalid = false,
    offContent,
    onContent,
    className,
    ...otherInputProps
  } = props;

  const { isChecked, onCheckboxChanged } = useCheckboxField({ checked, value, onValueChange });

  const content = isChecked ? onContent : offContent;

  const variantProps = useBuildVariantProps(
    'custom-toggle',
    {
      styles: isChecked ? 'selected' : 'unselected',
    },
    {
      disabled,
      invalid,
    },
  );

  return {
    variantProps,
    isChecked,
    handleChange: onCheckboxChanged,
    disabled,
    invalid,
    otherInputProps,
    required,
    content,
  };
};

export default usePresenter;